import { Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout/layout.component';
import { ComingSoonComponent } from './extrapages/coming-soon/coming-soon.component';
import { MaintenanceComponent } from './extrapages/maintenance/maintenance.component';
import { Error404Component } from './extrapages/error404/error404.component';
import { OfflineComponent } from './extrapages/offline/offline.component';
import { AuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.route').then(mod => mod.PAGE_ROUTES),
    canActivate: [AuthGuard],
  },
  // extrapages
  { path: 'pages-coming-soon', component: ComingSoonComponent },
  { path: 'pages-maintenance', component: MaintenanceComponent },
  { path: 'pages-404', component: Error404Component },
  { path: 'pages-offline', component: OfflineComponent },
];
